import styled from 'styled-components'

export const StyledNewsAlertsViewAll = styled.div``
